import { render, staticRenderFns } from "./DynamicAbout.vue?vue&type=template&id=7802a6e0&scoped=true"
import script from "./DynamicAbout.vue?vue&type=script&lang=js"
export * from "./DynamicAbout.vue?vue&type=script&lang=js"
import style0 from "./DynamicAbout.vue?vue&type=style&index=0&id=7802a6e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7802a6e0",
  null
  
)

export default component.exports